import { render } from "./VirtualReality.vue?vue&type=template&id=60109858"
import script from "./VirtualReality.vue?vue&type=script&lang=js"
export * from "./VirtualReality.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__